const EVENT_LABELS: Record<string, string> = {
  "sa-employee-enrolled": "Employee created",
  "sa-employee-activated": "Employee activated",
  "sa-employee-suspended": "Employee suspended",
  "sa-employee-restored": "Employee restored",
  "sa-employee-deleted": "Employee deleted",
  "sa-employee-purged": "Employee purged",
  "sa-employee-profile-updated": "Employee profile updated",
  "sa-employee-permissions-updated": "Permissions changed",
  "sa-employee-access-areas-updated": "Access areas changed",
  "sa-auth0-user-created": "Auth0 user created",
  "sa-auth0-user-updated": "Auth0 user updated",
  "sa-auth0-org-member-added": "Auth0 org member added",
  "sa-auth0-password-setup-sent": "Password setup email sent",
};

export function formatAuditActor(event: {
  actorName?: string | null;
  actorEmail?: string | null;
  actorSub?: string | null;
}): string {
  const name = event.actorName?.trim();
  const email = event.actorEmail?.trim();
  if (name && email) return `${name} (${email})`;
  if (name) return name;
  if (email) return email;
  if (event.actorSub) return event.actorSub;
  return "—";
}

export function formatAuditEventType(eventType: string | null | undefined): string {
  if (!eventType) return "Unknown event";
  return EVENT_LABELS[eventType] || eventType;
}

export function formatAuditReason(details: Record<string, unknown> | null | undefined): string {
  if (!details) return "—";
  const reason = details.reason;
  if (typeof reason === "string" && reason.trim()) {
    return reason.trim();
  }
  return "—";
}

export function formatAuditDetails(details: Record<string, unknown> | null | undefined): string {
  if (!details || Object.keys(details).length === 0) return "—";
  const { reason, ...rest } = details;
  const chunks: string[] = [];
  if (typeof reason === "string" && reason.trim()) {
    chunks.push(`Reason: ${reason.trim()}`);
  }
  for (const [key, value] of Object.entries(rest)) {
    if (value == null || value === "") continue;
    chunks.push(`${key}: ${String(value)}`);
  }
  return chunks.length > 0 ? chunks.join(" · ") : "—";
}
